import { type EngineStateBase } from '@blaze-runtime/engine-data-access';

export type TargetWorkflowActionType = 'delete-table' | 'delete-column' | 'open';

type TargetWorkflowAction =
  | TargetWorkflowRemoveTableAction
  | TargetWorkflowRemoveColumnAction
  | TargetWorkflowOpenAction;

interface TargetWorkflowRemoveTableAction {
  type: 'delete-table';
  tableId: string;
}
interface TargetWorkflowRemoveColumnAction {
  type: 'delete-column';
  tableId: string;
  columnId: string;
}
interface TargetWorkflowOpenAction {
  type: 'open';
  redirect?: boolean;
  openInNewTab?: boolean;
}

/** The workflow the editor is being steered towards, and why. */
export interface TargetWorkflow {
  nodeId?: string; // id of the targetted node
  workflow?: {
    pageId: string | null;
    pageName?: string;
    projectId?: string;
    projectName?: string;
    workflowCopiedFromId?: string | null;
    workflowId: string;
    workflowName?: string | null;
  };
  action?: TargetWorkflowAction;
  originProjectId?: string;
}

/** The field this library adds to the `engine` slice for workflow targeting. */
export interface TargetWorkflowSlice {
  targetWorkflow: TargetWorkflow;
}

/**
 * The engine slice as the target-workflow handler writes it. `targetWorkflow` is absent unless this
 * library's engine-state extension is registered.
 */
export type TargetWorkflowEngineState = EngineStateBase & Partial<TargetWorkflowSlice>;

export const initialTargetWorkflowSlice: TargetWorkflowSlice = {
  targetWorkflow: {
    action: undefined,
    nodeId: undefined,
    originProjectId: undefined,
    workflow: undefined,
  },
};
